export default __webpack_public_path__ + "static/media/webberDesktopApp3.529981b0.png";